import { getIdapiUserIdentifiers, } from './getIdapiUserData';
export const getBrazeUuid = async (ajaxUrl) => {
    return getIdapiUserIdentifiers(ajaxUrl)
        .then((data) => data.brazeUuid)
        .catch((error) => {
        window.guardian.modules.sentry.reportError(error, 'getBrazeUuid');
    });
};
